var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-detail"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.detailObj.title)+" ")]),_c('div',{staticClass:"time color-999"},[_vm._v(" "+_vm._s(_vm.detailObj.createTime)+" ")]),_c('div',{staticClass:"desc",domProps:{"innerHTML":_vm._s(_vm.detailObj.details)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }